import { render, staticRenderFns } from "./AddEditDepartments.vue?vue&type=template&id=7378b44a"
import script from "./AddEditDepartments.vue?vue&type=script&lang=js"
export * from "./AddEditDepartments.vue?vue&type=script&lang=js"
import style0 from "./AddEditDepartments.vue?vue&type=style&index=0&id=7378b44a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports